<template>
    <table class="flex-fill table table-head-fixed table-hover text-nowrap">
        <thead style="font-size: 0.85rem">
            <tr style="color: #1976d2; font-weight: 500">
                <th class="text-left text-nowrap" style="width: 12.5rem">
                    <button>
                        <span class="px-1">Billing ID</span>
                    </button>
                </th>
                <th class="text-left text-nowrap" style="width: 8rem">
                    <button>
                        <span class="px-1">Package</span>
                    </button>
                </th>
                <th class="text-left text-nowrap">
                    <button>
                        <span class="px-1">Machine ID</span>
                    </button>
                </th>
                <th class="text-left text-nowrap">
                    <button>
                        <span class="px-1">Machine name</span>
                    </button>
                </th>
                <th class=" text-nowrap">
                    <button>
                        <span class="px-1">Start/End time</span>
                    </button>
                </th>
                <th class="text-nowrap">
                    <button>
                        <span class="px-1">Used time</span>
                    </button>
                </th>
                <th class="text-right text-nowrap">
                    <button>
                        <span class="px-1">Used point</span>
                    </button>
                </th>
                <th class="text-right text-nowrap">
                    <button>
                        <span class="px-1">Credit back</span>
                    </button>
                </th>
                <th class="text-right text-nowrap">
                    <button>
                        <span class="px-1 mr-1">Balance</span>
                    </button>
                </th>
            </tr>
        </thead>
        <tbody style="color: #616161; font-size: 0.85rem">
            <tr :key="element.id" v-for="element in listData" style="background-color: #fff;">
                <td class="v-center text-nowrap text-center pt-2 pb-2 ">
                    <div v-if="element.billId">
                        {{ element.billId }}
                    </div>
                    <div v-else style="color: #bdbdbd">-- -- -- -- -- -- --</div>
                </td>
                <td class="v-center text-nowrap pt-2 pb-2">
                    <div>
                        <span class="ml-1">{{ element.packageName }}</span>
                    </div>
                </td>
                <td class="v-center text-nowrap pt-2 pb-2">
                    <div>
                        <span class="ml-1">{{ element.machineId }}</span>
                    </div>
                </td>
                <td class="v-center text-nowrap pt-2 pb-2">
                    <div>
                        <span class="ml-1">{{ element.machineName }}</span>
                    </div>
                </td>
                <td class="v-center text-nowrap pt-2 pb-2">
                    <div class="d-flex align-items-center">
                       <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5 3.984C4.54542 4.20953 4.18043 4.58211 3.96429 5.04124C3.74816 5.50036 3.69357 6.01906 3.80939 6.51312C3.92522 7.00718 4.20465 7.44758 4.60233 7.7628C5 8.07802 5.49255 8.24956 6 8.24956C6.50745 8.24956 7.00001 8.07802 7.39768 7.7628C7.79535 7.44758 8.07478 7.00718 8.19061 6.51312C8.30643 6.01906 8.25185 5.50036 8.03571 5.04124C7.81957 4.58211 7.45458 4.20953 7 3.984M6 3.25V5.5M10.25 6C10.25 8.34721 8.34721 10.25 6 10.25C3.65279 10.25 1.75 8.34721 1.75 6C1.75 3.65279 3.65279 1.75 6 1.75C8.34721 1.75 10.25 3.65279 10.25 6Z"
                                stroke="#19B5FE" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span class="ml-1 text-muted">{{ element.startTime | pretyDateUtcToLocal }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                       <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5 3.984C4.54542 4.20953 4.18043 4.58211 3.96429 5.04124C3.74816 5.50036 3.69357 6.01906 3.80939 6.51312C3.92522 7.00718 4.20465 7.44758 4.60233 7.7628C5 8.07802 5.49255 8.24956 6 8.24956C6.50745 8.24956 7.00001 8.07802 7.39768 7.7628C7.79535 7.44758 8.07478 7.00718 8.19061 6.51312C8.30643 6.01906 8.25185 5.50036 8.03571 5.04124C7.81957 4.58211 7.45458 4.20953 7 3.984M6 3.25V5.5M10.25 6C10.25 8.34721 8.34721 10.25 6 10.25C3.65279 10.25 1.75 8.34721 1.75 6C1.75 3.65279 3.65279 1.75 6 1.75C8.34721 1.75 10.25 3.65279 10.25 6Z"
                                stroke="#DF4F4F" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span class="ml-1 text-muted">{{ element.endTime | pretyDateUtcToLocal }}</span>
                    </div>
                </td>
                <td class="v-center text-nowrap pt-2 pb-2">
                    <div>
                        <strong class="ml-1">{{ element.durationSeconds | secondDuration}}</strong>
                    </div>
                </td>
                <td class="v-center text-right text-nowrap pt-2 pb-2">
                    <div>
                        <span class="ml-1  justify-content-end d-flex align-items-center">
                            <strong style="color: #ED8A34;">-{{ element.spentAmount | roundedMoney }}</strong>
                            <ir-point class="ms-1" color="#ED8A34" size="10px"/>
                        </span>
                    </div>
                </td>
                <td class="v-center text-right text-nowrap pt-2 pb-2">
                    <div>
                        <span class="ml-1  justify-content-end d-flex align-items-center">
                            <strong style="color: #529420;">+{{ element.cashbackAmount | roundedMoney }}</strong>  
                            <ir-point class="ms-1" color="#529420" size="10px"/>   
                        </span>
                    </div>
                </td>
                <td class="v-center text-nowrap text-right pt-2 pb-2">
                    <div class="mr-2">
                        <span class="ml-1 justify-content-end d-flex align-items-center text-primary">
                            <strong>{{ element.mainBalance | roundedMoney }}</strong>
                            <ir-point class="ms-1 text-primary" size="10px"/>   
                        </span>
                    </div>
                    <div class="mr-2">
                        <span class="ml-1  justify-content-end d-flex align-items-center">
                            <strong style="color: #529420;">{{ element.extraBalance | roundedMoney }}</strong>
                            <ir-point class="ms-1" color="#529420" size="10px"/>   
                        </span>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
    props: {
        listData: {
            type: Array,
            default() {
                return []
            }
        },
        dict: {
            type: Object,
            default() {
                return {}
            }
        },
        actions: {
            type: Object,
            default() {
                return {}
            }
        },
    }
}
</script>